import { request } from '@/utils/request'


export function recommendedVideo<T>(params?: any, data?: any) {
  return request.get<T>('/drama/drama-recommend-list', params);
}

export function getSeriesListApi<T>(params: any) {
  return request.get<T>('/drama/drama-list', params);
}

/**
 * 查询所有评论
 * @param params 
 * @returns 
 */
export function getVideoCommentsApi<T>(params: any) {
  return request.get<T>('/drama/all-comment', params)
}

/**
 * 评论
 * @param data 
 * @returns 
 */
export function videoCommentApi<T>(data: object) {
  return request.post<T>('/drama-user/comment', data);
}

/**
 * 点赞/取消点赞
 * @param data 
 */
export function videoLikeApi<T>(params: any) {
  return request.get<T>('/drama-user/video-like', params)
}

/**
 * 收藏/取消收藏
 * @param data 
 */
export function videoCollectApi<T>(params: any) {
  return request.get<T>('/drama-user/video-collect', params)
}

/**
 * 视频列表
 * @param params 
 * @param data 
 * @returns 
 */
export function videoSeriesListApi<T>(params?: any) {
  return request.get<T>('/drama/drama-video-list', params);
}

/**
 * 剧集明细
 * @param params 
 */
export function videoSeriesDetailApi<T>(params?: any) {
  return request.get<T>('/drama/drama-info', params);
}

/**
 * 解锁信息明细
 * @param params 
 */
export function videoUnlockDetailApi<T>(params?: any) {
  return request.get<T>('/drama-user/video-unlock-information', params);
}

/**
 * 解锁单集
 * @param params 
 * @returns 
 */
export function videoUnlockApi<T>(params?: any) {
  return request.get<T>('/drama-user/unlock', params);
}

/**
 * 解锁全集
 * @param params 
 * @returns 
 */
export function videoUnlockAllApi<T>(params?: any) {
  return request.get<T>('/drama-user/unlock-all', params);
}